export default class sidebarItemPosition {


    /**
    * Constructs a new parallax instance.
    *
    * @param container Where parallax applies to.
    */

    constructor(CSSSelector, wrapper, contentXL) {
        this.selector = CSSSelector;
        this.wrapper = wrapper;
        this.contentXL = contentXL;
    }


    /**
    * Find elements
    * @return {void}
    */
    findElements() {
        this.els = document.querySelectorAll(this.selector);
        if (this.els.length == 0) {
            // console.info('aucun élement trouvé');
        }
    }


    init() {
        // console.log('init');
        this.findElements();
        this.getPositionElement();
    }

    getContentXL() {
        // si on est sur l'accueil
        let contentXL = document.querySelectorAll(this.contentXL);

        if (contentXL.length == 0) {
            // console.info('aucun grand élément trouvé');
            return false;
        }
        return contentXL;

    }


    getArrayPositionContentXL() {
        let contentXL = this.getContentXL();

        if (contentXL.length >= 0) {
            const fullWidthItemsArray = new Array();
            for (let i = 0; i < contentXL.length; i++) {
                const itemTop = contentXL[i].getBoundingClientRect().top + document.documentElement.scrollTop;
                const itemBottom = itemTop + contentXL[i].offsetHeight;
                const height = contentXL[i].offsetHeight;


                let spaceAfter = 0;
                if (contentXL[i + 1]) {
                    spaceAfter = contentXL[i + 1].getBoundingClientRect().top + document.documentElement.scrollTop - itemBottom;
                } else {
                    spaceAfter = "illimited";
                }
                fullWidthItemsArray.push([itemTop, itemBottom, spaceAfter, height]);
            }
            // to-do : checker en ligne les tailles des images
            return fullWidthItemsArray;
        }
    }

    getHeightAvailable() {
        let wrapper = document.querySelector(this.wrapper);
        if (wrapper.length == 0) {
            // console.warning('Aucun wrapper trouvé');
        }
        return wrapper.offsetHeight;
    }


    delete() {
        for (let i = 0; i < this.els.length; i++) {
            this.els[i].removeAttribute('style');
        }
    }

    conflictImage(xlIndex, topItem, bottomItem) {
        const xlArray = this.getArrayPositionContentXL();

        if( bottomItem < xlArray[xlIndex][0] ){
            return false;
        }else{
            return true;
        }
    }



    getPositionElement() {
        let xlArray = this.getArrayPositionContentXL();

        // index pour le tableau des grandes images
        let xlIndex = 0;

        // pour chaque element de la sidebar 
        for (let i = 0; i < this.els.length; i++) {
            let sidebarItem = this.els[i];
    
            sidebarItem.style.opacity = '1';

            // faire une fonction getInfo item 
            // et faire object 

            const elMargeTop = parseInt(window.getComputedStyle(sidebarItem).getPropertyValue('margin-top'));
            const elMargeBottom = parseInt(window.getComputedStyle(sidebarItem).getPropertyValue('margin-bottom'));
            const elPaddingTop = parseInt(window.getComputedStyle(sidebarItem).getPropertyValue('padding-top'));
            let sidebarItemHeight = sidebarItem.offsetHeight + elMargeTop + elMargeBottom;
            let topItem = sidebarItem.getBoundingClientRect().top + document.documentElement.scrollTop - elMargeTop;
            let bottomItem = (topItem + sidebarItemHeight) - elMargeBottom;


            // Test si il y a des grandes images qui existe  et si l'Index de l'array existe 
            if (xlArray != undefined && xlArray[xlIndex] != null) {

                // console.log('encours' + xlIndex);

                const thereIseConflict = this.conflictImage(xlIndex, topItem, bottomItem);

                if (thereIseConflict == true) {
                    // on doit décaller l'élement car ça rentre dans un élément trop grand
                    // on parcours le tableau pour trouver une place, et on pars depuis l'index en cours 
                    // console.log('doit être décalée : index en cours : ' + xlIndex);

                    while (xlIndex < xlArray.length) {

                        let spaceAvailable = xlArray[xlIndex][2];
                        if (spaceAvailable >= sidebarItemHeight - elPaddingTop || spaceAvailable == 'illimited') {
                            // il y a de l'espace disponible : déplacement de l'élement grâce au padding top  : 
                            sidebarItem.style.paddingTop = (xlArray[xlIndex][1] - topItem) + elMargeTop + 'px'; // 
                            // on incrément l'index du tableau des grandes images pour passer à la suivante  : 
                            xlIndex++;
                            break; // on arrete le while, pour continuer de boucler sur les items de la sidebar
                        } else {
                            xlIndex++;
                            // console.log( "on continue pour trouver de l'espace ")
                        }
                    }
                }
            } else {
                // cache de la sidebar, si ya pas assez de place pour l'afficher 
                let wrapperMarge = document.querySelector('.container-sidebar').getBoundingClientRect().top + document.documentElement.scrollTop + document.querySelector('.container-sidebar').offsetHeight;
                if (wrapperMarge <= bottomItem) {
                    sidebarItem.style.display = "none";
                }
            };
        }
    }
}

